module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.4138/img/pumpkin.svg"